import * as yup from 'yup';

const validators = (__) => () => {
    return (
        yup.object({
            price: yup.string().required(__(`formCostEdit.price.error`)),
            comments: yup.string().required(__(`form.comments.error`))
        })
    )
}

export default validators
